import { useModelService } from 'services/model/model.service';
import { customKpi, InfoDrawerKpiEntry, measureKpi } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';

function useBreakdownInfoContentKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [netSlsGmvVal, netSlsCogRate, cm1Rate, netSlsFeeRate, netSlsLogCostRate, cm2Val, cm2Rate] = getMeasures([
    'netSlsGmvValExtExpOD',
    'netSlsCogRateExtExpOD',
    'cm1RateExtExpOD',
    'netSlsFeeRateExtExpOD',
    'netSlsLogCostRateExtExpOD',
    'cm2ValExtExpOD',
    'cm2RateExtExpOD',
  ]);

  return [
    measureKpi(netSlsGmvVal),
    customKpi('netSlsCogRateExt', {
      titleId: 'profitability.info.netSlsCogRateExt.title',
      descriptionId: 'profitability.info.netSlsCogRateExt.description',
      measure: netSlsCogRate,
    }),
    customKpi('cm1RateExt', {
      titleId: 'profitability.info.cm1RateExt.title',
      descriptionId: 'profitability.info.cm1RateExt.description',
      measure: cm1Rate,
    }),
    customKpi('netSlsFeeRateExt', {
      titleId: 'profitability.info.netSlsFeeRateExt.title',
      descriptionId: 'profitability.info.netSlsFeeRateExt.description',
      measure: netSlsFeeRate,
    }),
    customKpi('netSlsLogCostRateExt', {
      titleId: 'profitability.info.netSlsLogCostRateExt.title',
      descriptionId: 'profitability.info.netSlsLogCostRateExt.description',
      measure: netSlsLogCostRate,
    }),
    customKpi('cm2ValExt', {
      titleId: 'profitability.info.cm2ValExt.title',
      descriptionId: 'profitability.info.cm2ValExt.description',
      measure: cm2Val,
    }),
    customKpi('cm2RateExt', {
      titleId: 'profitability.info.cm2RateExt.title',
      descriptionId: 'profitability.info.cm2RateExt.description',
      measure: cm2Rate,
    }),
  ];
}

export function ProfitabilityBreakdownInfoContent() {
  const kpis = useBreakdownInfoContentKpis();

  return (
    <InfoDrawerKpis.Default kpis={kpis} whyUsefulDescriptionId="profitability.info.whyUseful.breakdown.description" />
  );
}
